var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPantano(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 16.5002C2.40539 15.0381 4.54141 14.2371 6.75 14.2502C10.5 14.2502 17.25 20.5832 23.25 14.5832",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9532 12.954C13.8494 11.6996 14.3044 10.1836 14.2472 8.643C14.253 8.39319 14.2088 8.14475 14.1172 7.91228C14.0255 7.67981 13.8884 7.46799 13.7138 7.28927C13.5391 7.11056 13.3305 6.96855 13.1002 6.8716C12.8699 6.77465 12.6226 6.7247 12.3727 6.7247C12.1228 6.7247 11.8755 6.77465 11.6452 6.8716C11.4149 6.96855 11.2063 7.11056 11.0317 7.28927C10.857 7.46799 10.7199 7.67981 10.6283 7.91228C10.5367 8.14475 10.4924 8.39319 10.4982 8.643C10.4982 9.199 9.63719 9.043 9.21619 8.608C9.09655 8.48405 9.00303 8.33733 8.94119 8.17654C8.87935 8.01575 8.85044 7.84417 8.85619 7.672C8.89719 6.4191 9.4237 5.23123 10.3245 4.35941C11.2252 3.48758 12.4296 3.00011 13.6832 3C18.8222 3 19.5142 8.465 21.3062 12.091",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 20.2502C2.40539 18.7881 4.54141 17.9871 6.75 18.0002C10.5 18.0002 17.25 24.3332 23.25 18.3332",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPantano);
export default __webpack_public_path__ + "static/media/Pantano.b9b223a689ada49816bc0b51b458928f.svg";
export { ForwardRef as ReactComponent };